import { ReclamationDetail } from '~/api/reclamations/_types';

export const useReclamationDetailStore = defineStore('reclamation', () => {
    const activeReclamation = ref<ReclamationDetail | null>(null);

    const reset = () => {
        activeReclamation.value = null;
    };

    return {
        activeReclamation,
        reset,
    };
});
